// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightInfoBanner-cls1_qce","cls2":"CiterightInfoBanner-cls2_VUv CiterightInfoBanner-cls1_qce"};